export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '2f2c2a01-3ef8-44b1-9e6e-f2fb834a08a1';
export const MODAL_CLOSE_SEC = 2.5;
